import React from 'react'
import styled from 'styled-components'
import { Menu as UikitMenu } from '@pancakeswap/uikit'
import { languageList } from 'config/localization/languages'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { usePriceCakeBusd } from 'state/farms/hooks'
import { useProfile } from 'state/profile/hooks'
import config from './config'
import UserMenu from './UserMenu'
import GlobalSettings from './GlobalSettings'

const StyledHeaderWrapper = styled.div`
  /* Direct child of StyledHeaderWrapper is UikitMenu's Wrapper */
  > div {
    /* Top Navigation Bar */
    > nav {
      background-color: ${({ theme }) => (theme.isDark ? '#27262c' : '#ffffff')} !important;
      background: ${({ theme }) => (theme.isDark ? '#27262c' : '#ffffff')} !important;
      border-bottom: 0px solid ${({ theme }) => (theme.isDark ? '#383241' : '#001378')} !important;
      box-shadow: 0 2px 8px rgba(0, 19, 120, 0.08) !important;
      height: 56px !important;
      z-index: 20 !important;

      @media screen and (min-width: 968px) {
        button[aria-label='Toggle menu'] {
          display: none !important;
        }
      }

      a[href='/'] image,
      a[aria-label*='home'] image {
        content: url(${({ theme }) => (theme.isDark ? '/images/swapimg/LogoWhite.png' : '/images/logo.png')});
      }

      svg {
        fill: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;
        color: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;
      }
    }

    /* BodyWrapper (contains Panel and Inner) */
    > div:nth-child(2) {
      /* Inner page content container */
      > div:nth-child(2) {
        margin-left: 0px !important;
        max-width: 100% !important;
        margin-top: 56px !important;
        background: #131732 !important;
      }

      /* Desktop horizontal top menu panel */
      @media screen and (min-width: 968px) {
        > div:first-child {
          position: fixed !important;
          top: 0 !important;
          left: 170px !important;
          right: 210px !important;
          height: 56px !important;
          width: auto !important;
          background: transparent !important;
          border: none !important;
          border-right: none !important;
          box-shadow: none !important;
          z-index: 21 !important;
          display: flex !important;
          flex-direction: row !important;
          align-items: center !important;
          justify-content: space-between !important;
          padding: 0 10px !important;
          overflow: visible !important;
          transform: none !important;

          /* PanelBody: Links row */
          > div:first-child {
            display: inline-flex !important;
            flex-direction: row !important;
            align-items: center !important;

            overflow: visible !important;
            margin: 0 !important;
            padding: 0 !important;

            /* Each menu entry */
            > div {
              position: relative !important;
              display: inline-flex !important;
              align-items: center !important;
         
              padding: 0 14px !important;
              cursor: pointer !important;
              background: transparent !important;
              border: none !important;
              box-shadow: none !important;

              &:hover {
                background-color: rgba(0, 19, 120, 0.04) !important;
                border-radius: 6px !important;

                > div:last-child {
                  display: flex !important;
                  flex-direction: column !important;
                }
              }

              /* Menu text */
              a,
              div {
                color: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;
                font-weight: 600 !important;
                font-size: 15px !important;
                text-decoration: none !important;
                box-shadow: none !important;
              }

              /* Menu icons & chevrons */
              svg {
                fill: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;
                color: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;

                image {
                  width: 24px !important;
                  height: 24px !important;
                }
              }

              /* Dropdown container */
              > div:last-child {
                display: none !important;
                position: absolute !important;
                top: 50px !important;
                left: 0 !important;
                min-width: 175px !important;
                max-height: none !important;
                background-color: ${({ theme }) => (theme.isDark ? '#27262c' : '#ffffff')} !important;
                border-radius: 8px !important;
                box-shadow: 0px 8px 24px rgba(0, 19, 120, 0.15) !important;
                border: 1px solid rgba(0, 19, 120, 0.1) !important;
                padding: 6px 0 !important;
                z-index: 100 !important;
                overflow: visible !important;

                a,
                div {
                  display: flex !important;
                  align-items: center !important;
                  height: 38px !important;
                  padding: 0 5px !important;
                  font-size: 14px !important;
                  font-weight: 500 !important;
                  background: transparent !important;
                  box-shadow: none !important;
                  text-decoration: none !important;
                  color: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;

                  &:hover {
                    background: ${({ theme }) => (theme.isDark ? '#383241' : 'rgba(0, 19, 120, 0.06)')} !important;
                    color: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;
                  }

                  * {
                    color: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;
                  }
                }
              }
            }
          }

          /* PanelFooter (Price & ThemeSwitcher) */
          > div:last-child {
            display: inline-flex !important;
            flex-direction: row !important;
            align-items: center !important;
            background: transparent !important;
            border: none !important;
            border-top: none !important;
            padding: 0 !important;
            height: 56px !important;
            width: auto !important;

            /* Social icons container (hide from top bar) */
            > div:first-child > div {
              display: none !important;
            }

            /* Price entry */
            > div:first-child {
              display: inline-flex !important;
              align-items: center !important;
              height: auto !important;
              padding: 0 10px !important;
            }

            /* Ample price text */
            a {
              display: inline-flex !important;
              align-items: center !important;
              text-decoration: none !important;

              div,
              span {
                color: #7a6eaa !important;
                font-weight: 700 !important;
                font-size: 14px !important;
              }
            }

            /* Theme switcher button */
            button {
              background: transparent !important;
              border: none !important;
              cursor: pointer !important;
              display: inline-flex !important;
              align-items: center !important;
              padding: 4px !important;

              svg {
                fill: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;
                color: ${({ theme }) => (theme.isDark ? '#FFFFFF' : 'rgb(0, 19, 120)')} !important;
                width: 20px !important;
                height: 20px !important;
              }
            }
          }
        }
      }
    }
  }
`

const Menu = (props) => {
  const { isDark, toggleTheme } = useTheme()
  const cakePriceUsd = usePriceCakeBusd()
  const { profile } = useProfile()
  const { currentLanguage, setLanguage, t } = useTranslation()

  return (
    <StyledHeaderWrapper>
      <UikitMenu
        userMenu={<UserMenu />}
        globalMenu={<GlobalSettings />}
        isDark={isDark}
        toggleTheme={toggleTheme}
        currentLang={currentLanguage.code}
        langs={languageList}
        setLang={setLanguage}
        cakePriceUsd={cakePriceUsd.toNumber()}
        links={config(t)}
        profile={{
          username: profile?.username,
          image: profile?.nft ? `/images/nfts/${profile.nft?.images.sm}` : undefined,
          profileLink: '/profile',
          noProfileLink: '/profile',
          showPip: !profile?.username,
        }}
        {...props}
      />
    </StyledHeaderWrapper>
  )
}

export default Menu
